export function getPageCopy(vm, key) {
  // Read locale on the Vue instance so computed() tracks i18n changes.
  const locale =
    (vm && vm.$i18n && vm.$i18n.locale) ||
    localStorage.getItem("lang") ||
    "en_us";

  if (vm && vm.$i18n) {
    // Force dependency on vue-i18n's reactive locale for pages using copy.*.
    void vm.$i18n.locale;
  }

  const localeMessage =
    (vm && vm.$i18n && vm.$i18n.getLocaleMessage(locale)) || {};
  const zhMessage =
    (vm && vm.$i18n && vm.$i18n.getLocaleMessage("zh_cn")) || {};

  return (((localeMessage.pages || {})[key]) || ((zhMessage.pages || {})[key]) || {});
}
